import axios from "axios";
import routes from "app/routes";

export const Actions = {
  load: (dispatch, enterpriseId) => {
    axios.get(routes.api.policy_invoices.index).then((resp) => {
      dispatch({ type: "load", invoices: resp.data.data });
    });
  },
  pay: (dispatch, invoiceId) => {
    axios.post(routes.api.policy_invoices.pay(invoiceId)).then((resp) => {
      dispatch({ type: "pay", invoice: resp.data.data });
    });
  },
};
